// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MMPUu","left":"styles_left__3FRV-"};